import React from 'react';
import PropTypes from 'prop-types';
import Tag from '../Tag';

const TagCertified = (props) => {
	const {
		certified: {
            src,
		    name
        } = {}
	} = props

	return (
        <Tag
            id="TagVehicleCertified"
            src={src}
            name={name}
            width="121px"
        />
	)
}

TagCertified.defaultProps = {
    certified: {
        src: '',
        name: 'Selo',
    }
}

TagCertified.propTypes = {
	certified: PropTypes.shape({
        src: PropTypes.string,
	    name: PropTypes.string
    })
}

export default TagCertified
